<template>
  <!-- 保单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true">
            <Option value="1">录单时间</Option>
            <Option value="2">投保日期</Option>
            <Option value="3">生效日期</Option>
            <Option value="4">承保时间</Option>
            <Option value="5">支付时间</Option>
          </Select>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.status" :transfer="true" clearable>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="input-item select-two select-two1">
          <Select
            v-model="searchParams.selectType"
            :transfer="true"
            @on-change="
              searchParams.verifyStatus = '';
              searchParams.doubleRecordStatus = '';
            "
          >
            <Option value="1">回执回访状态</Option>
            <Option value="2">双录状态</Option>
          </Select>
          <Select v-if="searchParams.selectType == 1" v-model="searchParams.receiptRevisitSatus" :transfer="true" clearable>
            <Option value="1">待回执</Option>
            <Option value="2">待回访</Option>
            <Option value="3">回执回访成功</Option>
          </Select>
          <lzDicSelect v-if="searchParams.selectType == 2" v-model="searchParams.doubleRecordStatus" dicType="DOUBLE_STATUS" transfer clearable></lzDicSelect>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable>
            <Option value="1">网销</Option>
            <!-- <Option value="2">电销</Option> -->
            <Option value="3">经代</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务来源</span>
          <Select v-model="searchParams.sellResource" :transfer="true" clearable>
            <Option value="1">分销</Option>
            <Option value="2">直营</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否自保件</span>
          <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否互保件</span>
          <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
      <div class="tab-box">
        <div class="tools-box">
          <!-- <Button
            type="primary"
            @click="toShowDownModal"
            ghost
            v-if="insureList.length > 0"
            >下载全部保单</Button
          > -->
          <Button type="primary" ghost @click="exportAll" v-if="insureList.length > 0">导出</Button>
        </div>
      </div>

      <div class="sedTab" v-if="isShowSed">
        <ul class="filterTab">
          <li :class="{ active: curActive == index }" v-for="(item, index) in sendTab" :key="index" @click="toggleSecondTab(index, item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="tipBox clearfix">
        <div class="left clearfix">
          <div>
            共<span class="total">{{ total }}</span
            >单
          </div>
          <div v-if="!hiddenTxt">
            已支付保费：
            <span class="other">{{ countObj.payedAmount }}</span
            >元
          </div>

          <div>
            退保保费：
            <span class="other">{{ countObj.refundedAmount }}</span
            >元
          </div>
        </div>
      </div>
      <loading :isShow="$root.$children[0].isShowLoading" />
      <div class="tableBox setTable">
        <div class="tableHead">
          <div class="item" style="flex: 0 0 200px">产品/险种名称</div>
          <div class="item">保费（元）</div>
          <div class="item">公司标保（元）</div>
          <div class="item">
            服务费（元）
            <Poptip trigger="hover" v-if="userInfo.userType != 4">
              <Icon type="ios-help-circle-outline" size="18" color="#fff" style="margin-left: -6px; margin-top: 2px" />
              <div slot="content" style="color: #333">当前机构服务费，包含给下级机构和业务员的服务费</div>
            </Poptip>
          </div>
          <div class="item">保单/险种状态</div>
          <div class="item">回执回访状态</div>
          <div class="item">出单业务员</div>
          <div class="item action" ref="operation">操作</div>
        </div>
        <div class="items" v-for="item in insureList" :key="item.id">
          <div class="tableTip">
            <div class="item">
              <span>承保时间:</span>
              <span>{{ item.insureTime | filterTime('YYYY-MM-DD') }}</span>
            </div>
            <div class="item">
              <span>保单号:</span>
              <span>{{ item.policyNo }}</span>
            </div>
            <div class="item">
              <span>投/被保险人:</span>
              <span>{{ item.holderName }}/{{ item.insuranceName }}</span>
            </div>
            <div class="item last">
              <span>所属团队:</span>
              <span v-if="item.groupName">{{ item.orgName }}/{{ item.groupName }}</span>
              <span v-else>{{ item.orgName }}</span>
            </div>
            <div class="item" v-if="item.source">
              <span>产品来源:</span>
              <span>{{ item.source }}</span>
            </div>
          </div>
          <div class="tBody">
            <div class="top">
              <div class="item" style="flex: 0 0 200px">
                {{ item.productName }}
              </div>
              <div class="item">{{ item.fee }}</div>
              <div class="item">{{ item.foldFyb }}</div>
              <div class="item">{{ item.totalCommission }}</div>
              <div class="item">{{ item.status | dealStatus }}</div>
              <div class="item">
                <span v-if="item.receiptStatus || item.verifyStatus">{{ showReceiptRevisit(item) }}</span>
                <Poptip trigger="hover" word-wrap width="500">
                  <Icon v-if="item.receiptStatus || item.verifyStatus" type="ios-help-circle-outline" size="18" />
                  <div slot="content" style="color: #333">
                    <span>回执回访记录：</span>
                    <div v-if="item.detailList && item.detailList.length > 0">
                      <div v-for="(i, index1) in item.detailList" :key="index1">
                        <span v-if="i.updateTime">{{ i.updateTime | filterTime('YYYY-MM-DD') }}&nbsp;</span>
                        <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="i.receiptStatus" v-if="i.receiptStatus"> </lzDicTxt>
                        <lzDicTxt dicType="VERIFY_STATUS" :dicCode="i.revisitStatus" v-if="i.revisitStatus"> </lzDicTxt>
                        <span v-if="i.remark">&nbsp;{{ i.remark }}</span>
                      </div>
                    </div>
                    <div v-else>无</div>
                  </div>
                </Poptip>
              </div>
              <div class="item">{{ item.salesmanName }}</div>
              <div class="item action"></div>
            </div>

            <div class="main" v-if="item.policyAdditionalList && item.policyAdditionalList.length > 0">
              <div class="item" style="flex: 0 0 200px">{{ item.mainProductName }}</div>
              <div class="item">{{ item.mainFee }}</div>
              <div class="item">{{ item.mainFoldFyb }}</div>
              <div class="item">{{ item.commission }}</div>
              <div class="item">{{ item.status | dealStatus }}</div>
              <div class="item"></div>
              <div class="item"></div>
              <div class="item action"></div>
            </div>

            <div class="other" v-if="item.policyAdditionalList && item.policyAdditionalList.length > 0">
              <div class="list" v-for="(items, indexs) in item.policyAdditionalList" :key="indexs">
                <div
                  class="item"
                  :class="{ 'inrWidth': idx == 0, 'action': its.key == 'action' }"
                  v-for="(its, idx) in policyAdditionalList"
                  :key="idx"
                  v-if="idx != 8"
                >
                  <span v-if="idx == 2">{{ items.foldFyb }}</span>
                  <span v-else-if="its.key === 'status'">{{ items[its.key] | dealStatus }}</span>
                  <span v-else>{{ items[its.key] }}</span>
                </div>
              </div>
            </div>

            <!-- entrance 1、线上 2、商户端录入 3、运营后台录入 -->
            <div class="Bar" :style="{ width: operationBtnW }" v-if="item.entrance == 2 || item.entrance == 3">
              <span @click="handlerPolicyDetail(item)" class="actionStyle">详情</span>
              <Dropdown
                :transfer="true"
                trigger="hover"
                @on-click="dropdownClick($event, item)"
                v-if="item.entrance == 2 || item.receiptUrl || item.revisitUrl"
              >
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="change" v-if="item.entrance == 2">变更记录</DropdownItem>
                  <DropdownItem name="copyReceipUrl" v-if="item.receiptUrl">复制回执链接</DropdownItem>
                  <DropdownItem name="copyRevisitUrl" v-if="item.revisitUrl">复制回访链接</DropdownItem>
                  <DropdownItem name="underlinePolicy" v-if="item.insuranceContract && item.insuranceContract.length != 0">电子保单</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="Bar" :style="{ width: operationBtnW }" v-else>
              <span @click="$refs.detailModal.open(item)" class="actionStyle">详情</span>
              <Dropdown
                :transfer="true"
                trigger="hover"
                @on-click="dropdownClick($event, item)"
                v-if="item.displayElectronicPolicy == 1 || item.receiptUrl || item.revisitUrl"
              >
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="policy" v-if="item.displayElectronicPolicy == 1">电子保单</DropdownItem>
                  <DropdownItem name="copyReceipUrl" v-if="item.receiptUrl">复制回执链接</DropdownItem>
                  <DropdownItem name="copyRevisitUrl" v-if="item.revisitUrl">复制回访链接</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef"></policyDetail>
    <!-- 线上保单详情  -->
    <detailModal ref="detailModal"></detailModal>
    <!-- 电子保单地址 -->
    <a ref="policyNoBox" :href="policyNo" target="_black"></a>
    <!-- 变更记录 -->
    <change-record ref="changeRecord"></change-record>

    <!-- 下载全部电子保单  -->
    <Modal v-model="showDownloadAll" title="下载全部电子保单" @on-ok="confirmEmail" width="500" :loading="$root.$children[0].modalLoading">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
        <FormItem prop="email" label="邮箱">
          <Input v-model="formValidate.email" placeholder="请输入您的电子邮箱" />
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="showPolicy" title="电子保单" width="800" :loading="$root.$children[0].modalLoading" footer-hide>
      <resource ref="resourceRef" :urlList="urlList" width="100px" height="100px"></resource>
    </Modal>
  </div>
</template>

<script>
import resource from './components/resource';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import detailModal from './components/detailModal';
import policyDetail from './components/policyDetail';
import changeRecord from './components/changeRecord';
import myForm from '@/components/commons/form';
import { mapState } from 'vuex';
import { pageTool } from '@/api/mixins';
import selectTree from '@/components/system/selectTree';
import { getInsureOrderList, getInsureStatistics, getProUrl, insureExportAll } from '@/api/httpList';
export default {
  mixins: [pageTool],
  components: {
    selectTree,
    changeRecord,
    detailModal,
    lzDicTxt,
    myForm,
    policyDetail,
    lzDicSelect,
    resource
  },
  props: {},
  data() {
    return {
      formValidate: {
        email: ''
      },
      ruleValidate: {
        email: [
          {
            required: true,
            message: '请输入验证码'
          },
          {
            pattern: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
            message: '请输入正确的邮箱'
          }
        ]
      },
      urlList: [], //资源列表
      showPolicy: false,
      showDownloadAll: false,
      hiddenTxt: false,
      policyNo: '',
      detailInfo: {},
      sendTab: [],
      tab: '',
      isShowSed: false,
      curActive: 0,
      policyAdditionalList: [
        {
          key: 'name',
          name: '产品/险种名称'
        },
        {
          key: 'fee',
          name: '保费（元）'
        },
        {
          key: 'mainFoldFyb',
          name: '公司标保（元）'
        },
        {
          key: 'commission',
          name: '服务费（元）'
        },
        {
          key: 'status',
          name: '保单/险种状态'
        },
        {
          key: '',
          name: ''
        },
        {
          key: '',
          name: ''
        },
        {
          key: '',
          name: ''
        },
        {
          key: 'action',
          name: ''
        }
      ],
      sendTabbase: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '未生效',
          value: '2'
        },
        {
          label: '已生效未过犹',
          value: '3'
        },
        {
          label: '部分退保',
          value: '4'
        },
        {
          label: '已过犹',
          value: '5'
        }
      ],
      sendTabother: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '犹内退保',
          value: '6'
        },
        {
          label: '犹外退保',
          value: '7'
        }
      ],
      countObj: {}, //统计数据
      searchParams: {
        applyOrgId: '',
        isSelfHold: '',
        isMutualHold: '',
        dateType: '4',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 5
      },
      insureList: [],
      companyList: [], //保司列表

      total: 0,
      showOrderdetail: false,
      //表单搜索字段
      searchForm: [],
      columns: [],
      tableDate: [],
      operationBtnW: ''
    };
  },
  watch: {
    payStatus(value) {
      if (value == 1) {
        this.sendTab = _.cloneDeep(this.sendTabbase);
        this.isShowSed = true;
        this.hiddenTxt = false;
      } else if (value == -1) {
        //已退保
        this.hiddenTxt = true;
        this.sendTab = _.cloneDeep(this.sendTabother);
        this.isShowSed = true;
      } else {
        this.isShowSed = false;
        this.hiddenTxt = false;
      }
      this.curActive = 0;
      this.searchParams.secondTab = ''; //复位二级tab
      this.getInsureList();
    }
  },
  computed: {
    ...mapState(['userInfo']),
    payStatus() {
      return this.searchParams.status;
    }
  },
  filters: {
    //保单险种状态
    dealStatus(val) {
      const m = new Map([
        ['1', '已承保'],
        ['-1', '已退保'],
        ['0', '已终止']
      ]);
      return m.get(val + '');
    },
    //回访状态
    dealVerifyStatus(val) {
      const m = new Map([
        ['0', '等待回访'],
        ['1', '回访成功'],
        ['2', '回访失败'],
        ['3', '无需回访']
      ]);
      return m.get(val + '');
    }
  },
  methods: {
    showReceiptRevisit(item) {
      if (item.receiptStatus == '0' || item.receiptStatus == '2') {
        return '待回执';
      } else if (item.verifyStatus == '0' || item.verifyStatus == '2') {
        return '待回访';
      } else if (item.receiptStatus == '' || item.verifyStatus == '') {
        return '无数据';
      } else {
        return '回执回访成功';
      }
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    handlerPolicyDetail(row) {
      this.$refs['policyDetailRef'].open(row);
    },
    // 下载电子保单
    confirmEmail() {
      this.$units.notCloseModal(this);
      // if(this.email)
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.showDownloadAll = false;
          this.initFilterObj();
          const obj = {
            ...this.formValidate,
            ...this.searchParams
          };
          this.$Spin.show();
          this.$http({
            type: 'POST',
            url: '/buz/policy/downloadAll',
            data: obj
          }).then(res => {
            this.$Spin.hide();
            this.$Message.success('文件已发送到您的邮箱');
          });
        }
      });
    },
    toShowDownModal() {
      this.showDownloadAll = true;
      this.$refs.formValidate.resetFields();
    },
    exportAll() {
      const params = this.initFilterObj();
      insureExportAll(params).then(res => {
        const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
        // const fileName = this.detailInfo.name + ".xls";
        const blob = new Blob([res.data]); //构造一个blob对象来处理数据
        // const fileName = "xx.xls";
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) {
          //支持a标签download的浏览器
          const link = document.createElement('a'); //创建a标签
          link.download = fileName; //a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); //执行下载
          URL.revokeObjectURL(link.href); //释放url
          document.body.removeChild(link); //释放标签
        } else {
          //其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
        // this.$Message.success("导出成功");
      });
    },
    //获取电子保单
    async getPro(item) {
      const res = await getProUrl(item.policyNo);
      if (res.data) {
        this.policyNo = res.data;
        const target = this.$refs.policyNoBox;
        this.$nextTick(() => {
          target.click();
        });
      }
    },
    //切换一级tab
    async toggleFirstTab() {
      if (this.searchParams.firstTab === this.copyFirstTab) return;
      this.searchParams.secondTab = '1'; //复位二级tab
      this.searchParams.pageNo = 1;
      this.getInsureList();
    },
    async toggleSecondTab(index, item) {
      this.curActive = index;
      this.searchParams.secondTab = item.value;
      this.searchParams.pageNo = 1;
      if (this.searchParams.secondTab === this.copySecondTab) return;
      this.getInsureList();
    },
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getInsureList();
    },

    //获取保单列表
    async getInsureList() {
      const params = this.initFilterObj();
      this.copyFirstTab = this.searchParams.firstTab; //备份
      this.copySecondTab = this.searchParams.secondTab;
      this.$root.$children[0].isShowLoading = true;
      getInsureOrderList(params)
        .then(res => {
          res.data.map(item => {
            if (item.insuranceContract) {
              item.insuranceContract = JSON.parse(item.insuranceContract);
            }
          });
          this.total = res.total;
          this.$root.$children[0].isShowLoading = false;
          this.insureList = res.data;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
      const statisDate = await getInsureStatistics(params);
      this.countObj = statisDate.data;
    },
    resetSearch() {
      this.searchParams = {
        applyOrgId: '',
        isSelfHold: '',
        isMutualHold: '',
        dateType: '4',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 5,
        firstTab: this.copyFirstTab,
        secondTab: this.copySecondTab
      };
      this.searchAjax();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.$root.$children[0].isShowLoading = true;
      this.getInsureList();
    },
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.date && params.date[0]) {
        if (params.dateType == 1) {
          //录单时间
          params.entryTimeBegin = params.date[0];
          params.entryTimeEnd = params.date[1];
        } else if (params.dateType == 2) {
          //投保日期
          params.holdTimeBegin = params.date[0];
          params.holdTimeEnd = params.date[1];
        } else if (params.dateType == 3) {
          //生效日期
          params.effectTimeBegin = params.date[0];
          params.effectTimeEnd = params.date[1];
        } else if (params.dateType == 4) {
          //承保时间
          params.insureTimeBegin = params.date[0];
          params.insureTimeEnd = params.date[1];
        } else if (params.dateType == 5) {
          //支付时间
          params.payTimeStart = params.date[0];
          params.payTimeEnd = params.date[1];
        }
      }
      delete params.selectType;
      delete params.dateType;
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;

      delete params.applyOrgId;
      return params;
    },
    operationBtnWFun() {
      this.operationBtnW = this.$refs.operation.offsetWidth + 'px';
    },
    // 更多操作
    dropdownClick(e, item) {
      if (e == 'change') {
        // 变更记录
        this.$refs.changeRecord.open(item);
      } else if (e == 'copyReceipUrl') {
        //复制回执链接
        this.$units.copyUrl(item.receiptUrl, true);
      } else if (e == 'copyRevisitUrl') {
        //复制回访链接
        this.$units.copyUrl(item.revisitUrl, true);
      } else if (e == 'policy') {
        //电子保单下载
        this.getPro(item);
      } else if (e == 'underlinePolicy') {
        this.goUnderlinePolicy(item);
      }
    },
    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    },
    goUnderlinePolicy(item) {
      if (item.insuranceContract.length > 1) {
        this.urlList = item.insuranceContract.map(i => {
          return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.insuranceContract[0];
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.insuranceContract.map(i => {
            return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else if (this.checkType(path) == 'pdf') {
          window.open(path, '_blank');
        } else {
          location.href = path;
        }
      }
    }
  },
  created() { },
  async mounted() {
    this.getInsureList();
    this.getCompanyList();
    this.operationBtnWFun();
    const that = this;
    window.onresize = () => {
      return (() => {
        this.operationBtnWFun();
      })();
    };
  }
};
</script>
<style lang="scss" scoped>
.policy {
  white-space: nowrap;
  &:hover {
    cursor: pointer;
  }
}
.items {
  margin-bottom: 15px;
}
.inrWidth {
  flex: 0 0 200px !important;
}
.verifyBox {
  background: #fff0ea;
  border: 1px solid #ffd8c7;
  padding: 4px;
  color: #ff7134;
  font-size: 12px;
  border-radius: 15px 15px 15px 0px;
  position: absolute;
  top: -12px;
  right: -63px;
}
/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  position: relative;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
  padding: 0;
  .title {
    font-size: 13px;
    font-weight: bold;
    color: #3c464f;
  }
}
/deep/ .formGroup:after {
  display: none;
}
/deep/ .formGroup .title {
  font-size: 13px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}
/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  height: unset !important;
  position: relative;
  padding: 0;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
}
.actionStyle {
  color: #236dff;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
}
.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3c464f;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 14px;
    background-color: #236dff;
    margin-right: 6px;
  }
  &::after {
    content: '';
    display: block;
    background-color: #eff3fc;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}
/deep/ .ivu-poptip-body {
  overflow: auto;
  max-height: 400px;
}
@import './order.scss';
</style>
